import { EffectCallback, useEffect, DependencyList } from 'react';

function useDebouncedEffect(
    effect: EffectCallback,
    delay: number,
    deps: DependencyList
) {
    useEffect(() => {
        const timer = setTimeout(() => effect(), delay);

        return () => clearTimeout(timer);
    }, deps);
}

export default useDebouncedEffect;
